import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  AshbyConfig,
  AshbyFieldCompact
} from '@dadohr/shared/domainTypes/integrations/ashby';
import { CF, FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import { callFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toAshbyConfigDoc = generateToDocFn<AshbyConfig>();

const COLLECTION = FS.ashbyIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const ashbyConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toAshbyConfigDoc
);

export const useAshbyConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(ashbyConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<AshbyConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,
            apiKey: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeAshbyConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};

export const getAshbyFields = async (orgId: string) => {
  const result = await callFirebaseFunction<AshbyFieldCompact[]>(
    CF.ashby.getFields,
    { orgId }
  );

  return result;
};
